var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';

function SvgAlertWarning(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "#FFF",
    d: "M12.469 4.532a4.157 4.157 0 013.53-1.932c1.443 0 2.78.73 3.531 1.932l11.658 18.872a3.895 3.895 0 01.011 3.98c-.725 1.235-2.072 2.004-3.553 2.02H4.338c-1.465-.016-2.812-.785-3.538-2.02a3.903 3.903 0 01.023-3.999L12.469 4.532zM3.193 24.737c-.244.41-.246.916-.004 1.327.242.412.691.668 1.164.673h23.278a1.383 1.383 0 001.18-.673 1.29 1.29 0 00.007-1.309L17.175 5.908A1.385 1.385 0 0016 5.267c-.48 0-.925.242-1.174.639L3.193 24.737zM14.625 12.07c0-.736.615-1.333 1.375-1.333s1.375.597 1.375 1.333v5.334c0 .736-.616 1.333-1.375 1.333-.76 0-1.375-.597-1.375-1.333V12.07zm.402 10.276a1.305 1.305 0 010-1.885 1.406 1.406 0 011.945 0c.537.52.537 1.365 0 1.885-.537.521-1.408.521-1.945 0z"
  }));
}

export default SvgAlertWarning;